import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material'

import React from 'react'
import { useTranslation } from 'react-i18next'

const NoIcon = () => null

const MEAL_OPTIONS = ['breakfast', 'lunch', 'dinner'] as const

type Props = {
  meal: string
}

const ServiceSelectionCard: React.FC<Props> = ({ meal }) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ height: '100%', pt: meal ? 1.5 : 0 }}>
      <FormControl fullWidth sx={{ height: '100%' }}>
        <InputLabel shrink>{t('cc:navBar.meal')}</InputLabel>
        <Select
          value={meal ?? ''}
          readOnly
          IconComponent={NoIcon}
          sx={{
            height: '100%',
            cursor: 'default',
            '& .MuiSelect-select': {
              py: '8.5px',
              cursor: 'default',
            },
          }}>
          {MEAL_OPTIONS.map((m) => (
            <MenuItem key={m} value={m}>
              {t(`cc:navBar.${m}`)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default ServiceSelectionCard
